// extracted by mini-css-extract-plugin
export default {"error":"fh9Zw6l5020OS60yCRG5","message":"HOksooEAJ83yMKkxeHQH"};